<div *ngIf="hasOutstandingBalance" (click)="expandBalances()">

  <ng-container
    *ngIf="!policy?.billingDetails || (policy?.billingDetails && policy.calculatedBalanceDetails?.currentMinAmtDue === 0)">
    <div class="policy-info-row" [ngClass]="{'mb-3': !isAcmic}">
      <span class="label-col">
        <div class="d-flex align-items-center" (click)="isMobile && !isAcmic && toggleTooltip($event, minAmtTooltip)">
          <div>{{ "MIN_AMT_DUE_DISCLAIMER" | translate }}</div>
          <div class="ml-1">
            <app-info-tooltip
              #minAmtTooltip
              *ngIf="!isAcmic"
              [content]="tooltipContent"
              [position]="'bottom'">
            </app-info-tooltip>
          </div>
        </div>
      </span>
      <span class="content-col highlight">$0.00</span>
    </div>
  </ng-container>

  <ng-container
    *ngIf="policy?.billingDetails && policy?.billingDetails[0]?.paymentDueDate && policy.calculatedBalanceDetails?.currentMinAmtDue !== 0">

    <ng-container
      *ngIf="policy.billingDetails[0].amountStillDue === 0 && policy.hasPriorYearBalance; else hasAmountDue">
      <div class="policy-info-row" [ngClass]="{'mb-3': !isAcmic}">
        <div class="label-col">
          <div class="d-flex align-items-center" (click)="isMobile && !isAcmic && toggleTooltip($event, minAmtTooltip)">
            <div>{{ "MIN_AMT_DUE_DISCLAIMER" | translate }}</div>
            <div class="ml-1">
              <app-info-tooltip
                #minAmtTooltip
                *ngIf="!isAcmic"
                [content]="tooltipContent"
                [position]="'bottom'">
              </app-info-tooltip>
            </div>
          </div>
        </div>
        <div class="content-col">
          <div class="highlight dflex-align-center">
            {{ policy.calculatedBalanceDetails?.currentMinAmtDue | currency }}
            <div *ngIf="policy.hasPriorYearBalance"
              [ngClass]="{'supporting-text supporting-marginleft': !isAcmic, 'ml-1': isAcmic}">
              {{ ' on ' }} {{ policy?.priorYearBalanceDueDate | customDateFormat }}
            </div>
          </div>
          <span *ngIf="policy?.financeCompany?.isPremiumFinanceCompany"
            class="fcompany display-inline margin-right mr8">
            (Finance Company)
          </span>
        </div>
      </div>
    </ng-container>

    <ng-template #hasAmountDue>
      <div class="policy-info-row" [ngClass]="{'mb-3': !isAcmic}">
        <div class="label-col"
          [ngClass]="{'highlight-outstanding-bal': policy.hasPriorYearBalance && policy.billingDetails[0].amountStillDue > 0 && isAcmic}">
          <div class="d-flex align-items-center" (click)="isMobile && !isAcmic && toggleTooltip($event, minAmtTooltip)">
            <div>{{ "MIN_AMT_DUE_DISCLAIMER" | translate }}</div>
            <div class="ml-1">
              <app-info-tooltip
                *ngIf="!isAcmic"
                #minAmtTooltip
                [content]="tooltipContent"
                [position]="'bottom'">
              </app-info-tooltip>
            </div>
          </div>
        </div>
        <div class="content-col">
          <div class="highlight dflex-align-center">
            {{ policy.calculatedBalanceDetails?.currentMinAmtDue | currency }}
            <div *ngIf="!policy.hasPriorYearBalance"
              [ngClass]="{'supporting-text supporting-marginleft': !isAcmic, 'ml-1': isAcmic}">
              {{ ' on ' }} {{ policy?.calculatedBalanceDetails?.paymentDate | customDateFormat }}
            </div>
          </div>
          <span *ngIf="policy?.financeCompany?.isPremiumFinanceCompany"
            class="fcompany display-inline margin-right mr8">
            (Finance Company)
          </span>
        </div>
      </div>
    </ng-template>

  </ng-container>
</div>